import React, { useEffect, useRef } from 'react';
import { themedColor } from '@lemonade-hq/cdk';
import styled from 'styled-components';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis-atomic';

export const Card = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  background-color: ${themedColor('cloud')};
  border-radius: 16px;
  text-align: center;
  transition: scale 0.1s ease-in-out;
  cursor: pointer;

  ${MEDIA_QUERIES.mobile`
        border-radius: 4px;
    `}
`;

export const CardWrapper = styled.div`
  ${MEDIA_QUERIES.desktop`
      width: 250px;
  `}
  ${MEDIA_QUERIES.tablet`
      width: 240px;
  `}
  ${MEDIA_QUERIES.mobile`
      width: 100%;
  `}
    @media (max-width: 375px) {
    width: 120px;
  }

  aspect-ratio: 1/1;
  height: 100%;
`;

interface ReviewCardProps {
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onClick: () => void;
}

export const ReviewCard: React.FC<React.PropsWithChildren<ReviewCardProps>> = ({
  children,
  onMouseEnter,
  onMouseLeave,
  onClick,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (onMouseEnter === undefined || onMouseLeave === undefined) return;
    wrapperRef.current?.addEventListener('mouseenter', onMouseEnter);
    wrapperRef.current?.addEventListener('mouseleave', onMouseLeave);

    return () => {
      wrapperRef.current?.removeEventListener('mouseenter', onMouseEnter);
      wrapperRef.current?.removeEventListener('mouseleave', onMouseLeave);
    };
  }, [onMouseEnter, onMouseLeave]);

  return (
    <CardWrapper ref={wrapperRef} onClick={onClick}>
      <Card>{children}</Card>
    </CardWrapper>
  );
};
